import React from "react";
import { motion } from "framer-motion";

export default function Section({ title, children }) {
  return (
    <section className="mt-10">
      <div className="-mx-6 md:mx-0">
        <motion.div className="w-full bg-[#A7C7E7] dark:bg-slate-700 px-6 py-2" layoutId={`section-${title}`}>
          <h2 className="text-lg font-semibold text-[#1E3A8A] dark:text-[#A7C7E7]">{title}</h2>
        </motion.div>
      </div>
      <div className="mt-4">{children}</div>
    </section>
  );
}
